
		import Async from "../../../../../../../home/ubuntu/.nvm/versions/node/v14.21.3/lib/node_modules/preact-cli/node_modules/@preact/async-loader/async.js";

		function load(cb) {
			require.ensure([], function (require) {
				var result = require("!!../../../../../../../home/ubuntu/.nvm/versions/node/v14.21.3/lib/node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--4-0!../../../../../../../home/ubuntu/.nvm/versions/node/v14.21.3/lib/node_modules/preact-cli/node_modules/source-map-loader/dist/cjs.js!./index.tsx");
				typeof cb === 'function' && cb(result);
			}, "route-login");
		}

		export default Async(load);
	